/**
 * Trusted pagegen bootstrap metadata embedded in generated event HTML.
 * Used on direct generated-page loads to skip the route-resolver round-trip.
 */

export type EventBootstrapPayload = {
  event_id: string;
  public_slug: string;
};

const BOOTSTRAP_ELEMENT_ID = "gruv-event-bootstrap";
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Reads `#gruv-event-bootstrap` JSON when present and matching the path slug.
 * Returns null when missing, malformed, or slug mismatch (SPA / shell loads).
 */
export function readTrustedEventBootstrap(pathSlug: string): EventBootstrapPayload | null {
  if (typeof document === "undefined") return null;
  const el = document.getElementById(BOOTSTRAP_ELEMENT_ID);
  if (!el) return null;
  const raw = el.textContent?.trim();
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<EventBootstrapPayload>;
    const eventId = typeof parsed.event_id === "string" ? parsed.event_id.trim() : "";
    const publicSlug = typeof parsed.public_slug === "string" ? parsed.public_slug.trim() : "";
    if (!UUID_PATTERN.test(eventId) || !publicSlug) {
      return null;
    }
    if (publicSlug !== pathSlug.trim()) {
      return null;
    }
    return { event_id: eventId, public_slug: publicSlug };
  } catch {
    return null;
  }
}
